<template>
  <v-container class="no-available text-center">
    <v-row class="text-center" no-gutters>
      <v-col>
        <div v-if="position === 'top'" v-html="message">
        </div>
         <a v-if="position === 'top' && getLogged"
              class="logout"
              @click="logout()"
          >
              <h1>Cerrar sesión</h1>
          </a>
        <img class="img-fluid" src="@/assets/images/no-available.png" alt="No Available" />
        <div v-if="position === 'bottom'" v-html="message">
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions,mapGetters} from "vuex";

export default {
  props: ["message", "position"],
  name: "RomaNoAvailable",

  methods: {
  ...mapActions({
    resetUser: "resetUser",
    resetAllPoll: "resetAllPoll"
    }),
  logout() {
    this.resetUser();
    this.resetAllPoll();
    // add a timer to wait 1 sec
    setTimeout(() => {
      window.location.href = process.env.VUE_APP_ROMA_LOGOUT_CAS;
      }, 500);
    },
  },
  computed: {
    ...mapGetters({
      getLogged:"getLogged"
    }),
  },
};
</script>

<style lang="scss">
  .logout{
    h1{
    color: #FF7400 !important;
    }
  }
  @import url('https://fonts.googleapis.com/css2?family=Cabin:wght@400;500;600;700&display=swap');
  .no-available {
    text-align: center;
    width: 100%;
    h1 {
      font-family: "Cabin", Regular,sans-serif !important;
      font-size: 26px;
      text-align: center;
      letter-spacing: 0;
      color: #484848;
      opacity: 1;
      font-weight: 300;
    }
    img {
      margin-top: 20px;
      width: 25%;
    }
  }

  @media (max-width: 800px) {
    .no-available {
      text-align: center;
      margin: 0 auto;
      h1 {
        font-size: 18px;
        font-weight: 300;
      }
      img {
        margin-top: 1px;
        width: 50%;
      }
    }
  }




</style>